import { render, staticRenderFns } from "./tm-slider.vue?vue&type=template&id=df7b54e6&scoped=true&"
import script from "./tm-slider.vue?vue&type=script&lang=ts&"
export * from "./tm-slider.vue?vue&type=script&lang=ts&"
import style0 from "./tm-slider.vue?vue&type=style&index=0&id=df7b54e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df7b54e6",
  null
  
)

export default component.exports